<ul>
  @for (i of outputData; track $index) {
    <li>
      <b>Code:</b> {{i.code}}
      <p>{{i.message}}</p>
    </li>
  }
</ul>
